// Quotes and attributions supplied in the role-page design reference.
export const ROLE_TESTIMONIALS = {
  eyebrow: 'Creative Leaders Using IMAI',
  heading: 'What our users say',
  quotes: [
    {
      body: '"Been burned by every ‘AI for fashion’ tool but this one actually knows our color standards. Picked a colorway, factory matched it first try, didn’t have to send a single lab dip correction."',
      attribution: 'Creative Director | Contemporary Womenswear Brand',
    },
    {
      body: '"The approve button actually starting the tech pack is the first AI feature that saved my team real hours. My technical designer didn’t believe me until she saw the BOM draft sitting in her queue."',
      attribution: 'Design Lead | Outerwear Studio',
    },
    {
      body: '"Showed the cost next to every fabric while I was still sketching. Killed my two most expensive ideas on day one instead of week six. Honestly worth it for that alone."',
      attribution: 'Founder | Independent Fashion Label',
    },
  ],
};
